import PropTypes from "prop-types";
import SvgImage from "../SvgImage";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  heroIconDefault: {
    "@media (max-width: 1440px)": {
      marginTop: "0"
    },
    "@media (max-width: 823px)": {
      "& img": {
        width: "100px",
        maxWidth: "100px",
      }
    }
  }
});

const HeroIcon = ({ classes, src, className }) => (
  <SvgImage
    src={src}
    className={className ? className : classes.heroIconDefault}
  />
);

HeroIcon.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object
};

export default injectSheet(styles)(HeroIcon);



// WEBPACK FOOTER //
// ./src/components/Hero/HeroIcon.jsx